import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIManager} from '../UIManager'
import {Scene} from '../UISceneTypes'
import {MatchmakingCardCategory} from '../../../../shared/scripts/ui_html/home_page/UIModeSelectorController'
import {AnalyticEventType, AnalyticEventCategory} from '../../../../../shared/entity_datas/EntityDatas'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {AudioManager, AudioType} from '@colonist/audio'
import {UILanguageButtonController} from '../../ui_language/UILanguageButtonController'

export class UILandingPageController {
    private readonly uiManager: UIManager
    private readonly landingPageContainerDiv: HTMLDivElement
    readonly playWithFriendsCTA: HTMLLinkElement

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager

        this.landingPageContainerDiv = document.getElementById('scene_landing_page_container') as HTMLDivElement
        this.playWithFriendsCTA = document.getElementById('landingpage_cta_playwithfriends') as HTMLLinkElement

        const playOnlineCTA = document.getElementById('landingpage_cta_playonline') as HTMLLinkElement
        const playOnMobileWebCTA = document.getElementById('landingpage_cta_playonweb') as HTMLLinkElement
        const appBannerButton = document.getElementById('app_banner_open_app_button') as HTMLButtonElement

        setElementOnClick(this.playWithFriendsCTA, () => this.clickPlayWithFriendsCTA())
        setElementOnClick(playOnlineCTA, () => this.clickPlayOnlineCTA())
        setElementOnClick(playOnMobileWebCTA, () => this.clickPlayOnMobileWebCTA())
        setElementOnClick(appBannerButton, () => void this.clickAppBannerButton())
        new UILanguageButtonController(this.landingPageContainerDiv)

        UILandingPageController.setupLandingPageTracking()
    }

    private clickPlayWithFriendsCTA() {
        AudioManager.play(AudioType.Click)
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPagePlayWithFriends,
            category: AnalyticEventCategory.LandingPage,
        })
        this.uiManager.sceneController.loadScene(Scene.Lobby)
    }

    private clickPlayOnlineCTA() {
        AudioManager.play(AudioType.Click)
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageExploreModes,
            category: AnalyticEventCategory.LandingPage,
        })
        this.uiManager.modeSelector.selectTab(MatchmakingCardCategory.Bots)
        this.uiManager.sceneController.loadScene(Scene.MainPage)
    }

    // eslint-disable-next-line class-methods-use-this
    private clickPlayOnMobileWebCTA() {
        AudioManager.play(AudioType.Click)
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPagePlayOnMobileWeb,
            category: AnalyticEventCategory.LandingPage,
        })
        window.location.href = '/mobile'
    }

    // eslint-disable-next-line class-methods-use-this
    private async clickAppBannerButton() {
        AudioManager.play(AudioType.Click)
        await CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageOpenApp,
            category: AnalyticEventCategory.LandingPage,
        })

        // Must be the colonist.io URL, otherwise Universal Deeplink will not be triggered
        window.location.href = 'https://colonist.io/open-app'
    }

    hide() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'none'
    }

    show() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'flex'
    }

    private static setupLandingPageTracking() {
        if(ClientUserState.abTests.LANDING_PAGE_HEADER != 'HIDE_LANDING_PAGE_HEADER') {
            const headerContent = document.getElementById('landing-page-header-content') as HTMLDivElement
            headerContent.classList.remove('hidden')
        }

        const loginButton = document.getElementById('landing-page-login-button') as HTMLAnchorElement | null
        const languageButton = document.getElementById('landingpage-language-button') as HTMLDivElement
        const footerRulesButton = document.getElementById('footer-rules-button') as HTMLDivElement
        const footerPrivacyButton = document.getElementById('footer-privacy-policy-button') as HTMLAnchorElement

        // eslint-disable-next-line no-restricted-syntax
        loginButton?.addEventListener('click', () => {
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedHeaderLogin,
                category: AnalyticEventCategory.Header,
                stringValue: 'landing_page',
            })
        })

        // eslint-disable-next-line no-restricted-syntax
        languageButton.addEventListener('click', () => {
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageLanguageSelector,
                category: AnalyticEventCategory.LandingPage,
            })
        })

        // eslint-disable-next-line no-restricted-syntax
        footerRulesButton.addEventListener('click', () => {
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageFooterRules,
                category: AnalyticEventCategory.LandingPage,
            })
        })

        // eslint-disable-next-line no-restricted-syntax
        footerPrivacyButton.addEventListener('click', () => {
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageFooterPrivacy,
                category: AnalyticEventCategory.LandingPage,
            })
        })
    }
}
